export default __webpack_public_path__ + "static/DreamClean-f74794b0c944b216e853b55f6937df10.png";